/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyMondayIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-monday" */ './utils').then((m) => m.MondayIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/monday/icon' },
);

const LazyMondaySearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-monday-search-result" */ './utils').then(
			(m) => m.MondaySearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/monday/search-result-icon' },
);

const LazyMondayIconBorderlessComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-monday-borderless" */ './utils').then(
			(m) => m.MondayIconBorderless,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/monday/icon-borderless' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const MondayIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyMondayIconComponent />
	</Suspense>
);

export const MondaySearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyMondaySearchResultIconComponent />
	</Suspense>
);

export const MondayIconBorderless = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyMondayIconBorderlessComponent />
	</Suspense>
);
